import classNames from 'classnames';
import React from 'react';
import styles from './UpdateCard.module.scss';

export interface Props {
  onClick?: () => void;
  className?: string;
  children: {
    avatar?: React.ReactElement;
    content: React.ReactElement;
    actionArea?: React.ReactElement;
  };
}
export const UpdateCard: React.FC<Props> = ({ children, className, onClick }) => {
  const { avatar, content, actionArea } = children;
  return (
    <div onClick={onClick} className={classNames(styles.container, className)}>
      {avatar}
      {React.cloneElement(content, {
        className: classNames(content.props.className, styles.content),
      })}
      {actionArea ? <div className={styles.actionArea}>{actionArea}</div> : null}
    </div>
  );
};
